//ThreeDemoViz.vue



<template>

	<div id="wrapper">
		<div id="container" @mousedown="onMouseDown" @mouseup="onMouseUp">
		</div>
	</div>

	<div id="container-draw">

		<div class="draw-title">
			Draw your building
		</div>

		<div class="container-button-draw">
		
			<button class="button-draw" type="button" id="button-draw-building" name="button-draw-building"
					title="Draw a closed polyline for your building's outline" @click="drawBuilding">
				<img class="icon" src="imgs/icons/icon-building.svg">
				<!-- <label class="button-draw-label" for="button-draw-building">Building</label> -->
			</button>
			<button class="button-draw" type="button" id="button-draw-core" name="button-draw-core"
					title="Select two points to add a building core" @click="drawCore">
				<img class="icon" src="imgs/icons/icon-core.svg">
				<!-- <label class="button-draw-label" for="button-draw-building">Building</label> -->
			</button>
			<button class="button-draw" type="button" id="button-edit" name="button-edit" @click="edit"
					title="Edit your building's geometry">
				<img class="icon" src="imgs/icons/icon-edit.svg">
			</button>

		</div>

	</div>

	<!-- Floor Height -->
	<div class="inputFields">
		<p class="inputText">Floor Height</p>
		<input id="sliderFloorHeight" type="range" class="range-slider" v-model="floorHeightValue" 
				min="2.0" max="5.0" step="0.1"  @change="updateFloorHeight"/> 
		<label for="sliderFloorHeight" id="sliderFloorHeightValue" class="sliderValue">
			{{ parseFloat(floorHeightValue).toFixed(1) }} m
		</label>
		<input class="input-number" type="number" v-model="floorHeightValue" />
	</div>

	<button id="tell-me" @click="onClickTestMe">
		Visualize Geometry
	</button>

	<!-- <div id="inputBar">
		<InputBar @updateMaterial="materialUpdate" @updateBuildingHeight="buildingHeightUpdate" @calculateClicked="calculate" @clearValuesClicked="clearValues"
					@updateLoadValue="loadValueUpdate" @updateFloorHeight="floorHeightUpdate" @updateXSpanValue="xSpanValueUpdate"
					@updateYSpanValue="ySpanValueUpdate" @updateBeamDistValue="beamDistValueUpdate" @updateStructuralSystem="structuralSystemUpdate"/>
	</div>

	<div id="resultBar">
		<ResultBar :carbon-data="carbonData" v-if="isResultBarShow"/>
	</div> -->

</template>

<script>



import * as THREE from "three";
import { PointTextHelper } from '@jniac/three-point-text-helper';

import * as MyFunctions from "../MyFunctions.js";
import * as ProfilLibrary from "../classes/ProfilLibrary.js";
import * as MemberViz from "../classes/MemberViz.js";
import * as StructuralMember from "../classes/StructuralMember.js";
import * as Color from "../classes/Color.js";


import { OrbitControls } from "three/examples/jsm/controls/OrbitControls";
import { EffectComposer } from "three/examples/jsm/postprocessing/EffectComposer";
import { RenderPass } from "three/examples/jsm/postprocessing/RenderPass";
import { TransformControls } from "three/examples/jsm/controls/TransformControls";





window.THREE = THREE;

THREE.Object3D.DefaultUp.set(0, 0, 1);

let container, renderer, scene, camera, orbitControl, composer, transformControl;

var count = 0;
var mouse = new THREE.Vector3();
var pos = new THREE.Vector3();
var buildingPts = [];
var corePts = [];
const lineHelperObjects = [];
const onUpPosition = new THREE.Vector2();
const onDownPosition = new THREE.Vector2();


var drawnLine;
var updatedLine;


var columns = [];
var beams = [];


// let sceneContent;

export default {
	data() {
		return {
			floorHeightValue: 3.0,
		};
	},
	methods: {
		updateFloorHeight: function(value) {
			// this.$emit('updateFloorHeight', this.floorHeightValue)
			// console.log(this.floorHeightValue)
		},
		init() {

			container = document.getElementById("container");

			// Camera
			camera = new THREE.PerspectiveCamera(60, container.clientWidth / container.clientHeight, 0.01, 10000000);
			// camera.position.set(50, 70, 40);
			// camera.position.set(1, 1, 1);
			camera.position.set(10, 16, 4);
			camera.lookAt(new THREE.Vector3());
			scene = new THREE.Scene();

			//Renderer
			// renderer = new THREE.WebGLRenderer({ antialias: true, alpha: true });
			renderer = new THREE.WebGLRenderer({ antialias: true, alpha: true });
			renderer.xr.enabled = true;
			renderer.setSize(container.clientWidth, container.clientHeight);
			renderer.setPixelRatio(window.devicePixelRatio);
			// renderer.setClearColor(0xf2f2f2);
			renderer.setClearColor(0xd4d4d4, 0);
			container.appendChild(renderer.domElement);

			//Composer
			composer = new EffectComposer(renderer);
			composer.addPass(new RenderPass(scene, camera));

			//Lights
			// const light = new THREE.SpotLight( 0xffffff, 1.5 );
			// light.position.set( 0, 1500, 200 );
			// light.angle = Math.PI * 0.2;
			// light.castShadow = true;
			// light.shadow.camera.near = 200;
			// light.shadow.camera.far = 2000;
			// light.shadow.bias = - 0.000222;
			// light.shadow.mapSize.width = 1024;
			// light.shadow.mapSize.height = 1024;
			// scene.add( light );

			// //Ambient light 
			const ambientLight = new THREE.AmbientLight(0xffffff, .4);
			scene.add(ambientLight);
			// //Directional light 
			const directionalLight = new THREE.DirectionalLight(0xffffff, .8);
			directionalLight.position.set(40, 40, 20);
			scene.add(directionalLight);


			//Light from AEC tech web viewer
			// scene.add(new THREE.AmbientLight(0xffffff));
			// let light = new THREE.DirectionalLight(0xffffff, 1);
			// light.position.set(-20, 40, 0);
			// scene.add(light);

			//Controls
			orbitControl = new OrbitControls(camera, renderer.domElement);
			orbitControl.enableDamping = true;
			orbitControl.dampingFactor = 0.2;
			orbitControl.update();
			orbitControl.addEventListener( 'change', this.render );

			transformControl = new TransformControls(camera, renderer.domElement)
			scene.add(transformControl)
			transformControl.addEventListener( 'change', this.render );
			transformControl.dampingFactor = 0;
			transformControl.translationSnap = 1;
			transformControl.showZ = false;
			transformControl.setSize(0.5)

			transformControl.addEventListener( 'dragging-changed', function ( event ) {
				orbitControl.enabled = ! event.value;
				// this.updateOutline;
			} );

			transformControl.addEventListener( 'dragging-changed', this.updateOutline );

			//Grid and Axes
			const mainGrid = new THREE.GridHelper( 100, 100 );
			mainGrid.geometry.rotateX( Math.PI / 2 );
			mainGrid.material.opacity = 0.25;
			mainGrid.material.transparent = true;

			const grid10m = new THREE.GridHelper( 100, 10 );
			grid10m.geometry.rotateX( Math.PI / 2 );
			grid10m.material.opacity = 0.45;
			grid10m.material.transparent = true;
			
			scene.add( mainGrid,  grid10m);

			const axesHelper = new THREE.AxesHelper( 3 );    //x-Axis -> red, y-Axis -> green, z-Axis -> blue
			scene.add( axesHelper )

			
			//Event listeners
			document.addEventListener( 'pointermove', this.onPointerMove );
			document.addEventListener( 'pointerdown', this.onPointerDown );
			document.addEventListener( 'pointerup', this.onPointerUp );

	


			// //Coord vis
			// //----------------------------------------------------------------------------

			// const mesh = new THREE.Mesh(
			// 	new THREE.IcosahedronGeometry(1, 0),
			// 	new THREE.MeshBasicMaterial({ color:'cyan', wireframe:true }),
			// )
			// scene.add(mesh)

			// const pth = new PointTextHelper({ charMax:10 })
			// scene.add(pth)

			// //Display some text
			// pth.display({ text:'hello!',  color:'cyan' })
			// pth.display({ text:'top',     color:'cyan', size:.5, position:new THREE.Vector3(0, 1, 0) })
			// pth.display({ text:'bottom',  color:'cyan', size:.5, position:{ x:0, y:-1, z:0 } })

			// //Display an array of vertices:
			// var vertices = [new THREE.Vector3(0,0,0), new THREE.Vector3(5,5,0),new THREE.Vector3(5,5,5), new THREE.Vector3(0,0,5)];
			// pth.displayVertices(vertices);

			

			//Line creation

			// for (let i = 0; i < 10; i++) {
			// 	var column1 = new THREE.Line3(new THREE.Vector3(0, i*3, 0), new THREE.Vector3(0, i*3, 3));
			// 	var column2 = new THREE.Line3(new THREE.Vector3(10, i*3, 0), new THREE.Vector3(10, i*3, 3));
			// 	var beam = new THREE.Line3(new THREE.Vector3(0, i*3, 3), new THREE.Vector3(10, i*3, 3));

			// 	columns.push(column1);
			// 	columns.push(column2);
			// 	beams.push(beam);	
			// }

			// for (let i = 0; i < 9; i++) {
			// 	var riegel1 = new THREE.Line3(new THREE.Vector3(0, i*3, 3), new THREE.Vector3(0, (i + 1)*3, 3));
			// 	var riegel2 = new THREE.Line3(new THREE.Vector3(10, i*3, 3), new THREE.Vector3(10, (i + 1)*3, 3));

			// 	beams.push(riegel1);
			// 	beams.push(riegel2);	
			// }

			// for (let i = 0; i < columns.length; i++) {
			// 	scene.add(MyFunctions.lineToGeometry(columns[i]));
			// }

			// for (let i = 0; i < beams.length; i++) {
			// 	scene.add(MyFunctions.lineToGeometry(beams[i]));
			// }
			
			// var ipeShape = ProfilLibrary.IPEShapes[5];
			// var ipeMesh = ProfilLibrary.IPEMeshes[5];	
			
			// ipeShape.rotation.z = Math.PI/2;
			// ipeMesh.rotation.z = Math.PI/2;

			// scene.add(ipeMesh);


			// var colMeshes = []; 

			// for (let i = 0; i < columns.length; i++) {
			// 	var colMesh = MemberViz.visualizeColumn(columns[i], ipeShape);
			// 	colMeshes.push(colMesh);
			// }

			// for (let i = 0; i < colMeshes.length; i++) {
				// console.log(colMeshes[i]);
				// colMeshes[i].rotation.z = Math.PI/2;
				// scene.add(colMeshes[i]);
				// colMeshes[i].computeBoundingSphere()
				// console.log(colMeshes[i].geometry.boundingSphere)
			// }

			// console.log(colMeshes);



			//Beams viz
			//-------------------------------------------------------
			//Lines
			var line1 = new THREE.Line3(new THREE.Vector3(0, -10, 3), new THREE.Vector3(-10, -10, 3));
			var line2 = new THREE.Line3(new THREE.Vector3(0, -20, 3), new THREE.Vector3(-10, -20, 3));

			//Beams
			//Steel
			var beam1 = new StructuralMember.Beam(new THREE.Vector3(0, -10, 3), new THREE.Vector3(-10, -10, 3), "Steel", "Primary", 2, 40);
			var beam2 = new StructuralMember.Beam(new THREE.Vector3(0, -20, 3), new THREE.Vector3(-10, -20, 3), "Steel", "Primary", 2, 40);
			beam1.crossSection = {  profilHeight: 0.18, area: 0.0023899999999999998, shape: ProfilLibrary.IPEShapes[6] };
			beam2.crossSection = {  profilHeight: 0.18, area: 0.0023899999999999998, shape: ProfilLibrary.IPEShapes[6] };
			//Concrete
			// var beam1 = new StructuralMember.Beam(new THREE.Vector3(0, -10, 3), new THREE.Vector3(-10, -10, 3), "Concrete", "Primary", 2, 40);
			// var beam2 = new StructuralMember.Beam(new THREE.Vector3(0, -20, 3), new THREE.Vector3(-10, -20, 3), "Concrete", "Primary", 2, 40);
			// beam1.crossSection = {  beamHeight: 0.38, area: 0.0924 };
			// beam2.crossSection = {  beamHeight: 0.38, area: 0.0924 };
			//Timber
			// var beam1 = new StructuralMember.Beam(new THREE.Vector3(0, -10, 3), new THREE.Vector3(-10, -10, 3), "Timber", "Primary", 2, 40);
			// var beam2 = new StructuralMember.Beam(new THREE.Vector3(0, -20, 3), new THREE.Vector3(-10, -20, 3), "Timber", "Primary", 2, 40);
			// beam1.crossSection = { beamHeight: 0.38, area: 0.0924 };
			// beam2.crossSection = { beamHeight: 0.38, area: 0.0924 };
			//Hybrid
			// var beam1 = new StructuralMember.Beam(new THREE.Vector3(0, -10, 3), new THREE.Vector3(-10, -10, 3), "Hybrid", "Primary", 2, 40);
			// var beam2 = new StructuralMember.Beam(new THREE.Vector3(0, -20, 3), new THREE.Vector3(-10, -20, 3), "Hybrid", "Primary", 2, 40);
			// beam1.crossSection = { beamHeight: 0.38, area: 0.0924 };
			// beam2.crossSection = { beamHeight: 0.38, area: 0.0924 };
			//Plate
			//Beam
			// var beam1 = new StructuralMember.Beam(new THREE.Vector3(0, -10, 3), new THREE.Vector3(-10, -10, 3), "Hybrid", "Primary", 2, 40);
			// var beam2 = new StructuralMember.Beam(new THREE.Vector3(0, -20, 3), new THREE.Vector3(-10, -20, 3), "Hybrid", "Primary", 2, 40);
			// beam1.crossSection = {  profilHeight: 0.18, area: 0.0023899999999999998, shape: ProfilLibrary.IPEShapes[6] };
			// beam2.crossSection = {  profilHeight: 0.18, area: 0.0023899999999999998, shape: ProfilLibrary.IPEShapes[6] };

			console.log(beam1, beam2);

			//Slab
			var slabPts = [new THREE.Vector3(0, 0, 3), new THREE.Vector3(0, 15, 3), new THREE.Vector3(15, 15, 3), new THREE.Vector3(15, 0, 3), new THREE.Vector3(0, 0, 3)]; 
			var slab = new StructuralMember.Slab(slabPts, "Steel", "Beam", 2, 5);

			slab.height = 0.2;
			// slab.height = { heightConcrete: 0.1, heightTimber: 0.2, widthTimber: 0.12 }; 

			console.log(slab.height);
 
			var beamMesh1 = MemberViz.visualizeBeam(beam1, beam1.shape,  "Beam", slab, 0.31);
			var beamMesh2 = MemberViz.visualizeBeam(beam2, beam2.shape,  "Beam", slab, 0.31);

			//Scene adding
			scene.add(new THREE.Line( MyFunctions.lineToGeometry(line1)), new THREE.LineBasicMaterial( { color: '0xf25eff' } ));
			scene.add(new THREE.Line( MyFunctions.lineToGeometry(line2)), new THREE.LineBasicMaterial( { color: Color.MaterialColor.beams } ));
			scene.add(beamMesh1);
			scene.add(beamMesh2);

		

			//Default Building Geometry
			// var pts = []
			// var pt1 = new THREE.Vector3(-25, -30, 0)
			// var pt2 = new THREE.Vector3(-25, 40, 0)
			// var pt3 = new THREE.Vector3(10, 40, 0)
			// var pt4 = new THREE.Vector3(10 ,20, 0)
			// var pt5 = new THREE.Vector3(-5, 20, 0)
			// var pt6 = new THREE.Vector3(-5, -10, 0)
			// var pt7 = new THREE.Vector3(15, -10, 0)
			// var pt8 = new THREE.Vector3(15, -30, 0)

			// pts = [pt1, pt2, pt3, pt4, pt5, pt6, pt7, pt8]

			// shape
			// var geomShape = new THREE.ShapeBufferGeometry(new THREE.Shape(pts));
			// var matShape = new THREE.MeshBasicMaterial({color:"blue"});
			// var shape = new THREE.Mesh(geomShape, matShape);
			// scene.add(shape);
			
			//Extrusion
			// const extrudeSettings = {
			// steps: 2,
			// depth: 18,
			// bevelEnabled: false,
			// bevelThickness: 1,
			// bevelSize: 1,
			// bevelOffset: 0,
			// bevelSegments: 1s
			// };

			// const extrGeometry = new THREE.ExtrudeGeometry( new THREE.Shape(pts), extrudeSettings );
			// const extrMaterial = new THREE.MeshBasicMaterial( { color: 0xf5f5f5 } );
			// extrMaterial.opacity = 0.3
			// extrMaterial.transparent = true
			// extrMaterial.wireframe = true
					
			// const extrMesh = new THREE.Mesh( extrGeometry, extrMaterial ) ;
			// scene.add( extrMesh );


			// Default Sphere Geometry
			// let geometry = new THREE.SphereGeometry(400, 32, 32);
			// let material = new THREE.MeshBasicMaterial({
			// 	color: 0x000000,
			// 	wireframe: true
			// });
			// let sphere = new THREE.Mesh(geometry, material);
			// scene.add(sphere);

			


		},
		
		drawBuilding() {
			buildingPts = [];
			count = 0;
			mouse = new THREE.Vector3();
			pos = new THREE.Vector3();

			scene.remove(drawnLine);

			console.log("buildingPts")
			console.log(buildingPts)
			console.log("count")
			console.log(count)

			//Raycaster for drawing tool
			const raycaster = new THREE.Raycaster()
			var plane = new THREE.Plane( new THREE.Vector3( 0, 0, 1), 0 );

			console.log("Draw building started")

			//Geometry
			var geometry = new THREE.BufferGeometry();
			var MAX_POINTS = 500;
			var positions = new Float32Array(MAX_POINTS * 3);
			geometry.addAttribute('position', new THREE.BufferAttribute(positions, 3));
			//Material
			var material = new THREE.LineBasicMaterial({ color: 0x000000, linewidth: 2 });
			//Line
			drawnLine = new THREE.Line(geometry, material);
			scene.add(drawnLine);

			window.addEventListener('mousemove', onMouseMove, false);
			window.addEventListener('mousedown', onMouseDown, false);
			window.addEventListener('keydown', onEscapeClicked, false);
			
			//Functions
			//---------------------------------------------------------------
	
			//Mouse down handler
			function onMouseDown(event) {

				if(event.button === 0){					//Gets the left mouse click
					if(buildingPts.length > 2)
					{
						if(buildingPts[buildingPts.length - 1].x == buildingPts[0].x 
						&& buildingPts[buildingPts.length - 1].y == buildingPts[0].y)
						{
							window.removeEventListener('mousemove', onMouseMove)
							return
						}
					}
					//On first click add an extra point
					if( count === 0 ){
						addPoint();
					}
					addPoint();

					console.log(buildingPts)
				}

				if(event.button === 2){					//Gets the left mouse rights -> closes the polyline
					buildingPts.push(buildingPts[0]);
					var positions = []
					for (let i = 0; i < buildingPts.length; i++) {
						positions.push(buildingPts[i].x, buildingPts[i].y, buildingPts[i].z)
					}
					const vertices = new Float32Array(positions);
					scene.remove(drawnLine);

					// // //Update line
					const geometry = new THREE.BufferGeometry();
					geometry.setAttribute( 'position', new THREE.BufferAttribute( vertices, 3 ) );
					const material = new THREE.LineBasicMaterial( { color: 0x000000 } );
					drawnLine = new THREE.Line( geometry,  material );
					scene.add( drawnLine );

					console.log("Draw building ended");
					window.removeEventListener('mousemove', onMouseMove);
					return;
				}
			}

			//Mouse move handler
			function onMouseMove(event) {

				if(buildingPts.length > 2)
				{
					if(buildingPts[buildingPts.length - 1].x == buildingPts[0].x 
					&& buildingPts[buildingPts.length - 1].y == buildingPts[0].y)
					{
						// console.log("Point is start point")
						window.removeEventListener('mousemove', onMouseMove);
						return;
					}
				}

				mouse.x = (event.clientX / window.innerWidth) * 2 - 1;
				mouse.y = -(event.clientY / window.innerHeight) * 2 + 1;
				mouse.z = 0;

				raycaster.setFromCamera( mouse, camera );
				var intersects = new THREE.Vector3();
				let planeIntersect = raycaster.ray.intersectPlane( plane, intersects );

				pos = new THREE.Vector3( Math.round(planeIntersect.x), Math.round(planeIntersect.y), 0);

				mouse.unproject(camera);
				if( count !== 0 ){
					updateLine();
				}
			}
			
			//Add point
			function addPoint(event){

				positions[count * 3 + 0] = pos.x;
				positions[count * 3 + 1] = pos.y;
				positions[count * 3 + 2] = pos.z;

				buildingPts.push(pos)

				count++;
				drawnLine.geometry.setDrawRange(0, count);
				updateLine();		
			}
			//Update line
			function updateLine() {
				positions[count * 3 - 3] = pos.x;
				positions[count * 3 - 2] = pos.y;
				positions[count * 3 - 1] = pos.z;

				drawnLine.geometry.attributes.position.needsUpdate = true;
			}
			//Exit
			function onEscapeClicked (event) {
				if(event.keyCode == 27){
					console.log("Escape clicked");
					scene.remove(drawnLine)
					window.removeEventListener('mousemove', onMouseMove);
					window.removeEventListener('mousedown', onMouseDown);
					return;
				}
			}
		},

		drawCore() {

			const MAX_POINTS = 5;

			// geometry
			const geometry = new THREE.BufferGeometry();
			// attributes
			const positions = new Float32Array( MAX_POINTS * 3 ); // 3 vertices per point
			geometry.setAttribute( 'position', new THREE.BufferAttribute( positions, 3 ) );
			// draw range
			var drawCount = 3; // draw the first 2 points, only
			geometry.setDrawRange( 0, drawCount );
			// material
			const material = new THREE.LineBasicMaterial( { color: 0xff0000 } );
			// line
			const line = new THREE.Line( geometry,  material );
			scene.add( line );

			const corePositions = line.geometry.attributes.position.array;

			var started = false;

			window.addEventListener('mousedown', onMouseDown, false);
			window.addEventListener('mousemove', onMouseMove, false);
			window.addEventListener('keydown', onEscapeClicked, false);

			function onMouseDown (event) {

				console.log("mouse down fired");

				if(started != true) {
					mouse.x = (event.clientX / window.innerWidth) * 2 - 1;
					mouse.y = -(event.clientY / window.innerHeight) * 2 + 1;
					mouse.z = 0;

					const raycaster = new THREE.Raycaster();
					var plane = new THREE.Plane( new THREE.Vector3( 0, 0, 1), 0 );

					raycaster.setFromCamera( mouse, camera );
					var intersects = new THREE.Vector3();
					let planeIntersect = raycaster.ray.intersectPlane( plane, intersects );

					// console.log(planeIntersect);

					//Pt1
					corePositions[ 0 ] = Math.round(planeIntersect.x);
					corePositions[ 1 ] = Math.round(planeIntersect.y);
					corePositions[ 2 ] = 0;

					// console.log(corePositions)

					line.geometry.setDrawRange( 1, drawCount++ );
					line.geometry.attributes.position.needsUpdate = true;

					started = true;
				}
				else if(started) {
					started = false; 

					window.removeEventListener('mousedown', onMouseDown, false);
					window.removeEventListener('mousemove', onMouseMove, false);
					window.removeEventListener('keydown', onEscapeClicked, false);

					console.log(corePositions)

					scene.remove(line);

					var corePoints = MyFunctions.positionsToPoints(corePositions);
					console.log(corePoints)

					const coreLineGeometry = new THREE.BufferGeometry().setFromPoints( corePoints );
					var coreLine = new THREE.Line( coreLineGeometry, new THREE.LineBasicMaterial( { color: 0x00499c } ));

					corePts.push(corePoints.slice(1, 5));
					scene.add(coreLine);
				}
			}

			function onMouseMove (event) {

				if(started) {
					mouse.x = (event.clientX / window.innerWidth) * 2 - 1;
					mouse.y = -(event.clientY / window.innerHeight) * 2 + 1;
					mouse.z = 0;

					const raycaster = new THREE.Raycaster()
					var plane = new THREE.Plane( new THREE.Vector3( 0, 0, 1), 0 )

					raycaster.setFromCamera( mouse, camera );
					var intersects = new THREE.Vector3();
					let planeIntersect = raycaster.ray.intersectPlane( plane, intersects );

					// console.log(planeIntersect)

					//Pt2
					corePositions[ 3 ] = Math.round(planeIntersect.x);
					corePositions[ 4 ] = corePositions[ 1 ];
					corePositions[ 5 ] = 0;
					//Pt3
					corePositions[ 6 ] = Math.round(planeIntersect.x);
					corePositions[ 7 ] = Math.round(planeIntersect.y);
					corePositions[ 8 ] = 0;
					//Pt4
					corePositions[ 9  ] = corePositions[ 0 ];
					corePositions[ 10 ] = Math.round(planeIntersect.y);
					corePositions[ 11 ] = 0;
					//Pt5
					corePositions[ 12 ] = corePositions[ 0 ];
					corePositions[ 13 ] = corePositions[ 1 ];
					corePositions[ 14 ] = 0;

					// console.log(corePositions)

					line.geometry.setDrawRange( 0, 5 );
					line.geometry.attributes.position.needsUpdate = true;
				}

			}

			function onEscapeClicked (event) {
				if(event.keyCode == 27){
					console.log("Escape clicked");
					scene.remove(drawnLine)
					window.removeEventListener('mousemove', onMouseMove);
					window.removeEventListener('mousedown', onMouseDown);
					return;
				}
			}			
		},
		onClickTestMe() {
			//Extrusion for member visualization
			var ipeShape = ProfilLibrary.IPEShapes[5];
			var ipeMesh = ProfilLibrary.IPEMeshes[5];			
			scene.add(ipeMesh);

			for (let i = 0; i < columns.length; i++) {
				var colMesh = MemberViz.visualizeColumn(columns[i], ipeShape);
				scene.add( colMesh );	
			}


			for (let i = 0; i < beams.length; i++) {

				var startVec = beams[i].start

				var deltaVec = new THREE.Vector3();
				// beams[i].delta(deltaVec);

				var rotationAxis = startVec.add(deltaVec)

				console.log(beams[i])
				// console.log(deltaVec)
				// console.log(rotationAxis)
				// console.log(rotationAxis.normalize())


				// ipeShape.rotateX( Math.PI / 2);
				var beamsMesh = MemberViz.visualizeColumn(beams[i], ipeShape);
				// beamsMesh.rotateOnAxis((rotationAxis),  Math.PI / 2);
				scene.add( beamsMesh );	
			}
		},
		updateOutline() {
			scene.remove(drawnLine);

			// console.log("Update")
			var linePts = [];
			for (let i = 0; i < lineHelperObjects.length; i++) {
				linePts.push(lineHelperObjects[i].position);
			}
			linePts.push(lineHelperObjects[0].position)

			var positions = []
			for (let i = 0; i < linePts.length; i++) {
				positions.push(linePts[i].x, linePts[i].y, linePts[i].z)
			}
			const vertices = new Float32Array(positions);

			scene.remove(updatedLine);

			// // //Update line
			const geometry = new THREE.BufferGeometry();
			geometry.setAttribute( 'position', new THREE.BufferAttribute( vertices, 3 ) );
			const material = new THREE.LineBasicMaterial( { color: 0x000000 } );
			updatedLine = new THREE.Line( geometry,  material );
			scene.add( updatedLine );

			updatedLine.geometry.attributes.position.needsUpdate = true; // required after the first render
		},
		edit() {
			buildingPts.splice(0, 2);
			for (let i = 0; i < buildingPts.length; i++) {
				this.addSphere(buildingPts[i])		
			}
			// console.log("Line Helper Objects");
			// console.log(lineHelperObjects);			
		},
		addSphere(position) {

			const geometry = new THREE.SphereGeometry(0.3)	//Radius, WidthSegments, HeightSegements
			const material = new THREE.MeshBasicMaterial( { color: 0xebebeb } );
			material.opacity = 1;
			material.transparent = true;
			const object = new THREE.Mesh( geometry, material );

			if ( position ) {
				object.position.copy( position );
			} 

			object.castShadow = true;
			object.receiveShadow = true;
			scene.add( object );
			lineHelperObjects.push(object);
			// return object;

		},
		onPointerMove( event ) {

			const raycaster = new THREE.Raycaster();
			const pointer = new THREE.Vector2();

			pointer.x = ( event.clientX / window.innerWidth ) * 2 - 1;
			pointer.y = - ( event.clientY / window.innerHeight ) * 2 + 1;

			raycaster.setFromCamera( pointer, camera );

			const intersects = raycaster.intersectObjects( lineHelperObjects, false );

			if ( intersects.length > 0 ) {
				const object = intersects[ 0 ].object;
				if ( object !== transformControl.object ) {
					transformControl.attach( object );
				}
			}
		},
		onPointerDown( event ) {
			onDownPosition.x = event.clientX;
			onDownPosition.y = event.clientY;
		},
		onPointerUp(event) {
			onUpPosition.x = event.clientX;
			onUpPosition.y = event.clientY;
			if ( onDownPosition.distanceTo( onUpPosition ) === 0 ) transformControl.detach();
		},
		onContainerResize() {
			camera.aspect = container.clientWidth / container.clientHeight;
			camera.updateProjectionMatrix();
			renderer.setSize(container.clientWidth, container.clientHeight);
		},
		animate() {
			renderer.setAnimationLoop(() => {
				// controls.update();
				composer.render();
				renderer.render(scene, camera);
			});
		},
		render() {
			renderer.render(scene, camera)
		},
	// onMouseDown() {},
	// onMouseUp() {}
	},
	mounted() {
		this.init();
		this.animate();
		setTimeout(this.loadModel, 2000);
  }
};
</script>



<style scoped>

#container {
  width: 100%;
  height: 100%;
  padding: 0px;
  margin: 0px;
  overflow: hidden;

}

#wrapper {
  /* background: black; */
  width: 100%;
  height: 100%;
  margin: 0px;
  padding: 0px;
  overflow: hidden;
}

.draw-title{
	opacity: 0;
	color: black;
	font-family: Roboto;
	font-weight: 300;
	font-size: 14px;
	text-align: center;
	/* margin-left: 30px; */
	/* padding-top: 20px; */
	display: flex;
    justify-content: space-between; 
    align-items: center;
}

#container-draw {
	padding: 10px;
	height: 80px;
	max-width: 200px;
	top: 85%;
	left: 50%;
	border: 2px solid rgba(30, 30, 30, 0.2);
	position: fixed;
	background: transparent;
	border-radius: 10px;
	display: block;
	justify-content: space-between;
	transform: translate(-50%, 0);
}


.container-button-draw {
	margin-top: 10px;
	align-items: center;
	display: flex;
}

.button-draw {
	padding: 5px;
	margin-right: 15px;
	border-radius: 50%;
	border: 2px solid rgba(107, 107, 107, 1);
	height: 50px;
	width: 50px;
	background: #f0f0f0;
	cursor: pointer;
}

.button-draw:last-child {
	margin-right: 0;
}

.button-draw:hover {
	/* background: rgb(219, 219, 219); */
	border: 1px solid rgba(66, 66, 66, 1);
}

.button-draw:active {
	opacity: .8;
}

.icon {
	height: 24px;
}

.button-edit {
	padding: 5px;
	/* margin-right: 10px; */
	border-radius: 5px;
	border: 1px solid rgba(0, 0, 0, 1);
	height: 30px;
	width: 35px;
	background: white;;
}

.gradient-test {
	height: 650px;
	width: 450px;
	top: 25%;
	left: 60%;
	border: 2px solid rgba(30, 30, 30, 0.2);
	position: fixed;
	background: #d4d4d4;
	/* background-image: linear-gradient(red, yellow); */
	background-image: linear-gradient(rgba(220, 220, 222, 0.8),rgba(194, 194, 207, 0.8));
}

#tell-me {
	top: 75%;
	left: 5%;
	position: fixed;
}


/* ------------------------------------------------
Slider
 -------------------------------------------------- */
.inputFields {
	position: fixed;
	top: 10%;
	left: 10%;
	display: flex;
	justify-content: space-between; 
	align-items: center;
	color: #7d7d7d;
	font-weight: 400;
	font-size: 10px;
	margin-bottom: 15px;
	text-transform: uppercase;
	letter-spacing: 1px;
}

.inputText {
	color: #7d7d7d;
	font-weight: 4old;
	font-size: 10px;
	text-transform: uppercase;
	letter-spacing: 1px;
	margin: 0;
	width: 140px;
	margin-right: 2px;
	/* border: 2px solid black; */
}

.range-slider {
	-webkit-appearance: none;
	left: 100px;
	height: 1px;
	border-radius: 5px;
	background: #7d7d7d;
	width: 80px;
}

.range-slider::-webkit-slider-thumb {
  -webkit-appearance: none; /* Override default look */
  appearance: none;
  width: 10px; /* Set a specific slider handle width */
  height: 10px; /* Slider handle height */
  border-radius: 5px;
  border: 1px solid black;
  background: #fff; /* Green background */
  cursor: pointer; /* Cursor on hover */
  transition: all 0.1s ease-in;
}

.range-slider::-webkit-slider-thumb:hover {
  transform: scale(1.3);
}

.sliderValue {
	color: #303030;
}

.input-number {
	background: transparent;
	border: none;
	width: 50px;

}

</style>